(function () {
  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('nvznAppData:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const action = button.dataset.mode || 'floor';
        const selectedVariant = getSelectedVariant();
        if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
        log('Button action:', action);
        log('Selected variant:', selectedVariant);
        if (action === 'floor') {
          handleFloorPreview(selectedVariant);
        } else if (action === 'wall') {
          handleWallPreview(selectedVariant);
        }
      });
    });
  }

  function handleFloorPreview(selectedVariant) {
    const variantDimensions = extractDimensions(selectedVariant.option1);
    Nvzn3D.displayFloorPreview({
      clientId: nvznAppData.app.nvznFloorClientID,
      imageUrl: selectedVariant.ar_image,
      width: variantDimensions.width,
      length: variantDimensions.length,
      units: variantDimensions.units,
    });
  }

  function handleWallPreview(selectedVariant) {
    const variantDimensions = extractDimensions(selectedVariant.option1);
    Nvzn3D.displayArtPreview({
      clientId: nvznAppData.app.nvznArtClientID,
      productId: nvznAppData.product.id,
      imageUrl: selectedVariant.ar_image,
      width: variantDimensions.width,
      height: variantDimensions.length,
      units: variantDimensions.units,
    });
  }

  function getSelectedVariant() {
    // get variant id from form, as theme doesn't support query params for selected variant
    const variantId = document.querySelector('form[action*="/cart/add"] input[name="id"]').value;
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant || null;
  }

  function extractDimensions(sizeString) {
    // Handles inputs like "110x83cm (3.5ft)": drop parenthetical, strip "cm", split on x.
    const withoutParens = sizeString.split('(')[0].trim();
    const cleaned = withoutParens.replace(/cm[s]?/i, '').trim();
    const [width, length] = cleaned.split(/[xX×]/).map((s) => parseFloat(s.trim()));
    return { width, length, units: 'cm' };
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();